import React, { useEffect, useState } from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ApiServices from 'services/ApiServices';
import {Home} from '@material-ui/icons/';
import Form from 'components/Form/FormTwoColumns';
import {useStyles} from './style';
import { Container, Grid } from '@material-ui/core';
import DialogLoadingMessage from 'components/BackDrop';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';

const  Filtros= (props)=> {
    let isFindState = false, idDepartamento = '', isReturn = false;

    const classes = useStyles(),
    // [datosDelUsuario, setDatosDelUsuario] = useState({})
    [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});

    const obteneruUsuariosDS =async ()=>{
        isFindState = false
        setLoadingMessage({loading: true, title:'Cargando usuarios. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if((props.catalogosCambioDePuesto?.arrayTabalaUsuariosDS.length > 0)){
            newElements.usuarios.list = props.catalogosCambioDePuesto?.arrayTabalaUsuariosDS
            isFindState = true
        }
        if(isFindState){
            setLoadingMessage({loading: false, title:''})
            setElements(newElements);
            return ;
        }

        try{
            let response = await ApiServices.tabalaUsuariosDS.listRegisterCriteria();
            if(response.error){
            }else {  
                var datos = response.data
                Object.keys(datos).forEach((element, key, _array) =>{
                    newElements.usuarios.list.push({
                        id: element,
                        name: datos[element].nombre,
                        departamento: datos[element].departamento,
                        municipio: datos[element].municipio,
                        idPuesto: datos[element].codUsuario,
                        puesto: datos[element].puesto,
                    });                                
                }) 
                props.CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_USUARIOS_DS(newElements.usuarios.list)
            } 
        }catch(exception){
            newElements.usuarios.list=[];
        }
        setElements(newElements);
        setLoadingMessage({loading: false, title:''})
    };
    const ObtenerPuestosEnMemoria = (departamentoID, municipioID) =>{
        let newElements= Object. assign({}, elements);
        const currentMunicipality = props.catalogosCambioDePuesto?.arrayPuestos?.filter( ({departamento, municipio}) => Number(departamento) === Number(departamentoID) && Number(municipio) === Number(municipioID));
        if(currentMunicipality?.length > 0) {
            newElements.puesto.list=currentMunicipality;
            newElements.puesto.value = null
            setElements(newElements);
            setLoadingMessage({loading: false, title:''})
            return true;
        } else return false;
    }     
    const obtenerPuestos =async ()=>{
        if(!elements.departamento?.value?.id && !elements.municipios?.value?.id){
            // showMessagePersonalizedPosition('warning','¡Oopss!', 'Seleccione departamento y municipio','center')
            return;
        }else if(!elements.municipio?.value?.id){
            // showMessagePersonalizedPosition('warning','¡Oopss!', 'Seleccione municipio','center')
            elements.puesto.value = null
            elements.puesto.list=[];
            return;
        }
        elements.puesto.list=[];
        isFindState = false
        isFindState = ObtenerPuestosEnMemoria(elements.departamento?.value?.id, elements.municipio?.value?.id)
        setLoadingMessage({loading: true, title:'Cargando puestos. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 

        if(isFindState){
            setLoadingMessage({loading: false, title:''})
            setElements(newElements);
            return ;
        }
        try{
            ApiServices.puestoEmpadronamiento.searchCriteria.clear();
            ApiServices.puestoEmpadronamiento.searchCriteria.setOperator("and");
            ApiServices.puestoEmpadronamiento.searchCriteria.addEquals("departamento", elements.departamento.value?.id);
            ApiServices.puestoEmpadronamiento.searchCriteria.addEquals("municipio",elements.municipio.value?.id);
            let response = await ApiServices.puestoEmpadronamiento.listRegisterCriteria();
            if(response.error){
            }else {  
                var datos = response.data
                Object.keys(datos).forEach((element, key, _array) =>{
                    newElements.puesto.list.push({
                        id: datos[element].codigoPuesto,
                        name: datos[element].nombrePuesto,
                        departamento: datos[element].departamento,
                        municipio: datos[element].municipio,
                    });                                
                }) 
                props.CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_PUESTOS(newElements.puesto.list)
                newElements.puesto.value = null
            } 
        }catch(exception){
            newElements.puesto.list=[];
        }
        setElements(newElements);
        setLoadingMessage({loading: false, title:''})
    };
    const obtenerDepartamentos =async ()=>{
        isFindState = false
        setLoadingMessage({loading: true, title:'Cargando departamentos. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if((props.catalogos?.departamentoResidencia.length > 0)){
            newElements.departamento.list = props.catalogos?.departamentoResidencia
            isFindState = true
        }
        if(isFindState){
            setLoadingMessage({loading: false, title:''})
            setElements(newElements);
            return ;
        }

        try{
            let response = await ApiServices.departamentos.listRegisterCriteria();
            if(response.error){
            }else {  
                var datos = response.data
                Object.keys(datos).forEach((element, key, _array) =>{
                    if(datos[element].id === "23" || datos[element].id === "24" || datos[element].id === "25"){
                    }else{
                        newElements.departamento.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                        });                                
                    }
                }) 
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_RESIDENCIA(newElements.departamento.list)
            } 
        }catch(exception){
            newElements.departamento.list=[];
        }
        setElements(newElements);
        setLoadingMessage({loading: false, title:''})
    };
    //cargamos los municipios en base al departamento vecindad seleccionado
    const ObtenerMunicipiosEnMemoria = (municipio, departamento, idDepartamento) =>{
        let newElements= Object. assign({}, elements); 
        const currentMunicipality = props.catalogos?.municipios?.filter( ({departamentoId}) => Number(departamentoId) === Number(idDepartamento));
        if(currentMunicipality?.length > 0) {
            newElements[municipio].list=currentMunicipality;
            setElements(newElements);
            setLoadingMessage({loading: false, title:''})
            return true;
        } else return false;
    }    
    const obtenerMuninipios =async (event)=>{
        isFindState = false
        setLoadingMessage({loading: true, title:'Cargando municipios de residencia. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if((event?.target?.value === "" && elements.departamento.value?.id === 0) || (event?.target?.value === undefined && elements.departamento.value?.id === undefined)){
            elements.municipio.value = null
            elements.municipio.list = []
            elements.puesto.value = null
            elements.puesto.list=[];
            setLoadingMessage({loading: false, title:''})
            return;
        }
        if(event?.target?.value){
            idDepartamento = event.target.value
            isReturn = ObtenerMunicipiosEnMemoria('municipio', 'departamento', event.target.value)
        }else {
            if(event === undefined && elements.departamento.value?.id){
                isReturn = ObtenerMunicipiosEnMemoria('municipio', 'departamento', elements.departamento.value?.id)
            }else isReturn = true;
        }

        if(isReturn){
            setLoadingMessage({loading: false, title:''})
            return;
        }else{
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamento);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipio.list=[];
                }else {               
                    elements.municipio.value =  null;
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)                        
                    newElements.municipio.list=response.data;                        
                }                    
            }catch(exception){
                elements.municipio.value =  null;
                newElements.municipio.list=[];
            }                    
        }        
        setLoadingMessage({loading: false, title:''})
        setElements(newElements);
    };    
    const getSelectedUser = (user) => {
        var usuarios = props.catalogosCambioDePuesto?.arrayTabalaUsuariosDS
        Object.keys(usuarios).forEach((element, key, _array) =>{
            if(usuarios[element].id === user?.target?.value){
                elements.departamentoActual.value = ('Departamento: '+usuarios[element].departamento?.nombre)
                elements.municipioActual.value = ('Municipio: '+usuarios[element].municipio?.name)
                elements.descripcionDelPuesto.value = ('Descripción del Puesto: '+usuarios[element].puesto)
                return
            }
        })        
    }
    const [elements, setElements] = useState({
        titleUsers:{
            idelement: "titleUsers", title:'Seleccione usuario', position:"center", value: "", isError:false, elementType:'titleCustom',
            backgroundColor:'#143766', color: "white", fontSize: '17px', show: true,
        },
            usuarios: {
                idelement: "usuarios", value: null, label: "Usuarios *", pattern:"^[0-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione usuario'], isError:false, elementType:'autocompleteV2', list: [], handler: getSelectedUser,
                focus: {ejecutar: true, function: obteneruUsuariosDS}
            },
        titleData:{
            idelement: "titleData", title:'Datos del usuario', position:"center", value: "", isError:false, elementType:'titleCustom',
            backgroundColor:'#143766', color: "white", fontSize: '17px', show: true,
        },              
            departamentoActual:{
                idelement: "departamentoActual", position:"center",  isError:false, elementType:'labelCustom',
                value: 'Departamento: ' , colorChip:'#143766', letraColorChip: "white",
            },
            municipioActual:{
                idelement: "municipioActual", position:"center",  isError:false, elementType:'labelCustom',
                value: 'Municipio: ' ,colorChip:'#143766', letraColorChip: "white",
            },
            descripcionDelPuesto:{
                idelement: "descripcionDelPuesto", position:"center",  isError:false, elementType:'labelCustom',
                value: 'Descripción del Puesto: ' , colorChip:'#143766', letraColorChip: "white",
            },        
            puestoActual:{
                idelement: "puestoActual", position:"center",  isError:false, elementType:'labelCustom',
                value: 'Puesto: ' , colorChip:'#143766', letraColorChip: "white",
            },        
        tituloNuevoPuesto:{
            idelement: "tituloNuevoPuesto", title:'Complete los campos para asignarle nuevo lugar de empadronamiento', position:"center", value: "", isError:false, elementType:'titleCustom',
            backgroundColor:'#143766', color: "white", fontSize: '17px', show: true,
        },
            departamento: {
                idelement: "departamento", value:null, label: "Departamento *", pattern:"^[1-9][0-9]*$", validators: ['required'],
                errorMessages:['Seleccione departamento'], isError:false, elementType:'autocompleteV2', list: [],
                handler: obtenerMuninipios, focus: {ejecutar: true, function: obtenerDepartamentos},
            },
            municipio: {
                idelement: "municipio", value: null, label: "Municipio *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione municipio'], isError:false, elementType:'autocompleteV2', list: [], 
                focus: {ejecutar: true, function: obtenerMuninipios}, handler: obtenerPuestos,
            },        
            puesto: {
                idelement: "puesto", value: null, label: "Puesto *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione puesto'], isError:false, elementType:'autocompleteV2', list: [], 
            },        
    })

    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Cambiar puesto","icon": <Home />, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},   
    });

    return (
        <Container maxWidth="lg">
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>                
            <Grid className={classes.colorComponente}>
                <Grid item xs={12} direction="row" justify="center" alignItems="center">
                    <Form   elements= {elements} buttonList={buttonList}/>
                </Grid>
                {/* <Grid item xs={12}  style={{ paddingBottom: '15px', paddingTop: '15px'}}>
                    <div className={classes.centerTitle}><Divider /> <strong>Seleccione los usuarios que desea filtrar</strong> <Divider /></div>
                </Grid > */}
                {/* <Grid item xs={12} container direction="row" justify="center" alignItems="center" style={{ paddingBottom: '10px', paddingTop: '10px'}}>
                    {(listadoDeUsuariosActivosEnElSistema.length > 0) ?
                        <SelectCustom arrayDeDatos={listadoDeUsuariosActivosEnElSistema} ObtenerUsuariosSeleccionados={ObtenerUsuariosSeleccionados}
                            placeholder={'Seleccionar Usuario'} label={"Usuarios *"} mensajeError={'Seleccione un usuario.'}
                        />
                    :''
                    }
                </Grid >                         */}
                {/* <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                    <Typography color="textSecondary" >
                        {description}
                        <br></br>
                        {datosRequeridosTexto}
                    </Typography>
                </Grid> */}
                {/* <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                    <BotonPersonalizado title={"Generar reporte"}  botonPersonalizado={true} function={GenerarReporteEstadisticasSolicitudes} icon={<PictureAsPdf />} /> 
                </Grid> */}
                <div className={classes.lineaDegradadaBottom}></div>
            </Grid>
        </Container>
    );   
}


export default connect(mapStateToProps, mapDispatchToProps)(Filtros);



